import { TaskItem } from '../types/dashboardTypes';

// TaskStatus is a string (not limited to enum)
export type TaskStatus = string;

export interface TaskDragData {
  id: string;
  status: TaskItem['status'];
  index: number;
}

// Type IDs for dnd-kit
export const Types = {
  TASK: 'task' as const,
  COLUMN: 'column' as const,
};

// Type guard to check if a value is a valid DnD type
export function isValidDndType(value: any): value is keyof typeof Types {
  return value === Types.TASK || value === Types.COLUMN;
}